/* ============================================================
   GOOTER - Consent Gate fur Third-Party-Tracker
   DSGVO/TDDDG-konform: Tidio, Trustedshops und andere Marketing-
   Scripts laden erst nach Cookie-Zustimmung.
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'gooter_consent_v1';

  function getConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && parsed.c ? parsed.c : null;
    } catch (e) { return null; }
  }

  /* --- Pending-Scripts: warten auf Consent ----------------- */

  var pending = {
    marketing: [],
    analytics: [],
    functional: []
  };

  /**
   * Registriert ein Script das erst nach Consent geladen werden darf.
   * @param {string} category - 'marketing' | 'analytics' | 'functional'
   * @param {Function} loader - Funktion die das Script initialisiert
   */
  function registerGated(category, loader) {
    if (!pending[category]) {
      console.warn('[gooter-consent-gate] unknown category:', category);
      return;
    }
    var c = getConsent();
    if (c && c[category]) {
      try { loader(); } catch (e) { console.error(e); }
    } else {
      pending[category].push(loader);
    }
  }

  /* --- Trigger: wird vom Cookie-Banner aufgerufen ---------- */

  function flushCategory(category) {
    if (!pending[category]) return;
    var loaders = pending[category];
    pending[category] = [];
    loaders.forEach(function (loader) {
      try { loader(); } catch (e) { console.error(e); }
    });
  }

  function onConsentChanged(newConsent) {
    if (!newConsent) return;
    Object.keys(pending).forEach(function (cat) {
      if (newConsent[cat]) flushCategory(cat);
    });
  }

  /* --- Tidio-Gate: live chat treated as 'functional' --------
     Tidio chat widget is a customer support tool, classified as functional
     (essential for service delivery), not marketing. Functional cookies are
     either accepted by default or whitelisted by most users, so the chat
     widget appears on all storefront pages reliably. */

  function gateTidio() {
    // Hide via CSS until functional consent (functional defaults to ON)
    var style = document.createElement('style');
    style.id = 'gooter-tidio-gate';
    style.textContent = '#tidio-chat,#tidio-chat-iframe,iframe[id^="tidio-"]{display:none !important;visibility:hidden !important;}';
    document.head.appendChild(style);

    function removeGate() {
      var s = document.getElementById('gooter-tidio-gate');
      if (s) s.remove();
      // Trigger tidio show if API is loaded
      if (window.tidioChatApi && typeof window.tidioChatApi.show === 'function') {
        try { window.tidioChatApi.show(); } catch(e) {}
      }
    }

    var c = getConsent();
    // No consent record yet OR functional cookies accepted -> show immediately.
    // Functional cookies default to ON in our banner, so first-time visitors
    // see the chat without needing to interact with the cookie banner.
    if (!c || c.functional !== false) {
      removeGate();
    } else {
      registerGated('functional', removeGate);
    }
  }

  /* --- Public API ----------------------------------------- */

  window.GooterConsentGate = {
    register: registerGated,
    onChange: onConsentChanged,
    getConsent: getConsent
  };

  /* --- Auto-Init Tidio-Gate ------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gateTidio);
  } else {
    gateTidio();
  }

  /* --- Listen for cookie-consent updates ----------------- */
  // The cookie banner script writes to localStorage; we observe storage events
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      var c = getConsent();
      onConsentChanged(c);
    }
  });

  // Also poll once after typical banner-interaction delay
  // (storage event fires only across tabs, not same-tab)
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-action="accept-all"], [data-action="save-settings"], [data-action="reject-all"]');
    if (!t) return;
    setTimeout(function () {
      var c = getConsent();
      onConsentChanged(c);
    }, 300);
  });
})();
